import CustomFieldTooltip from "./CustomFieldTooltip";
import { TextField, TextFieldProps } from "@mui/material";
import { forwardRef, useState } from "react";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";

/** Keep transient empty/decimal entry local; calculations and saves receive zero. */
const CustomTextField = forwardRef<
  HTMLDivElement,
  TextFieldProps & { preserveBlank?: boolean; overridden?: boolean; explanation?: string }
>(function CustomTextField({ preserveBlank, overridden, explanation, ...props }, ref) {
  const [draft, setDraft] = useState<string | null>(null);
  const numeric =
    !props.select && (props.type === "number" || props.inputProps?.inputMode === "decimal");
  const field = (
    <TextField
      {...props}
      ref={ref}
      type={numeric ? "text" : props.type}
      value={numeric && draft !== null ? draft : props.value}
      inputProps={{
        ...props.inputProps,
        ...(numeric ? { inputMode: "decimal" } : {}),
        ...(overridden ? { "aria-description": "Manually overridden" } : {}),
      }}
      sx={[
        ...(Array.isArray(props.sx) ? props.sx : [props.sx ?? {}]),
        ...(overridden && !props.error
          ? [
              {
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  { borderColor: draftColors.blue, borderWidth: "1px" },
              },
            ]
          : []),
      ]}
      onChange={(event) => {
        const raw = event.target.value;
        if (numeric && !preserveBlank && (raw === "" || raw === ".")) {
          setDraft(raw);
          props.onChange?.({
            ...event,
            target: { ...event.target, value: "0" },
            currentTarget: { ...event.currentTarget, value: "0" },
          });
        } else {
          setDraft(null);
          props.onChange?.(event);
        }
      }}
      onBlur={(event) => {
        setDraft(null);
        props.onBlur?.(event);
      }}
    />
  );
  return explanation !== undefined ? (
    <CustomFieldTooltip text={explanation}>{field}</CustomFieldTooltip>
  ) : (
    field
  );
});
export default CustomTextField;
